(function () {
  function initCareTabs(root) {
    if (!root || root.dataset.thlCareTabsReady === "true") return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-thl-care-target]"));
    var rail = root.querySelector(".thl-care-tabs__list");
    var stickyHost = root.closest(".shopify-section") || root.parentElement || root;

    if (!tabs.length) return;

    root.dataset.thlCareTabsReady = "true";
    stickyHost.classList.add("thl-care-tabs-host");
    stickyHost.style.position = "sticky";
    stickyHost.style.top = "var(--thl-care-sticky-offset, var(--header-height, 72px))";
    stickyHost.style.zIndex = "30";
    root.style.position = "relative";
    root.style.top = "auto";

    function getHeaderOffset() {
      var selectors = [
        ".header__outer-wrapper",
        ".shopify-section-group-header-group",
        ".site-header",
        "header"
      ];
      var header = null;

      selectors.some(function (selector) {
        header = document.querySelector(selector);
        return Boolean(header);
      });

      if (!header) return 72;

      var rect = header.getBoundingClientRect();
      var style = getComputedStyle(header);
      var isStickyHeader = style.position === "sticky" || style.position === "fixed";

      if (!isStickyHeader) return 72;

      return Math.max(0, Math.round(rect.bottom));
    }

    function syncStickyOffset() {
      stickyHost.style.setProperty("--thl-care-sticky-offset", getHeaderOffset() + "px");
    }

    syncStickyOffset();
    window.addEventListener("resize", syncStickyOffset, { passive: true });
    window.addEventListener("load", syncStickyOffset, { once: true });

    function getTarget(key) {
      return document.getElementById("care-" + key) || document.querySelector('[data-thl-care-section="' + key + '"]');
    }

    function getOffset() {
      var hostStyle = getComputedStyle(stickyHost);
      var hostTop = parseFloat(hostStyle.top || 0);

      if (!Number.isFinite(hostTop)) hostTop = 0;

      return root.getBoundingClientRect().height + hostTop + 12;
    }

    function centerTab(tab) {
      if (!rail || !tab) return;

      var targetLeft = tab.offsetLeft - (rail.clientWidth - tab.offsetWidth) / 2;
      rail.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: "smooth"
      });
    }

    function setActive(key, shouldFocus) {
      tabs.forEach(function (tab) {
        var selected = tab.getAttribute("data-thl-care-target") === key;
        tab.setAttribute("aria-selected", selected ? "true" : "false");
        tab.tabIndex = selected ? 0 : -1;

        if (selected) {
          centerTab(tab);
          if (shouldFocus) tab.focus({ preventScroll: true });
        }
      });
    }

    function scrollToSection(key, shouldFocus) {
      var target = getTarget(key);

      setActive(key, shouldFocus);
      if (!target) return;

      window.scrollTo({
        top: target.getBoundingClientRect().top + window.pageYOffset - getOffset(),
        behavior: "smooth"
      });

      window.history.replaceState(null, "", "#care-" + key);
    }

    function updateActiveFromScroll() {
      var offset = getOffset();
      var currentKey = tabs[0].getAttribute("data-thl-care-target");

      tabs.forEach(function (tab) {
        var key = tab.getAttribute("data-thl-care-target");
        var target = getTarget(key);

        if (!target) return;

        if (target.getBoundingClientRect().top - offset <= 1) {
          currentKey = key;
        }
      });

      setActive(currentKey, false);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        scrollToSection(tab.getAttribute("data-thl-care-target"), false);
      });

      tab.addEventListener("keydown", function (event) {
        var nextIndex = index;

        if (["ArrowLeft", "ArrowRight", "Home", "End"].indexOf(event.key) === -1) return;

        event.preventDefault();

        if (event.key === "ArrowRight") nextIndex = (index + 1) % tabs.length;
        if (event.key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = tabs.length - 1;

        scrollToSection(tabs[nextIndex].getAttribute("data-thl-care-target"), true);
      });
    });

    var ticking = false;

    window.addEventListener("scroll", function () {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(function () {
        syncStickyOffset();
        updateActiveFromScroll();
        ticking = false;
      });
    }, { passive: true });

    var initial = window.location.hash.replace("#care-", "").replace("#", "");
    var hasInitial = tabs.some(function (tab) {
      return tab.getAttribute("data-thl-care-target") === initial && getTarget(initial);
    });

    if (hasInitial) {
      window.setTimeout(function () {
        scrollToSection(initial, false);
      }, 0);
    } else {
      updateActiveFromScroll();
    }
  }

  function initAllCareTabs() {
    Array.prototype.slice.call(document.querySelectorAll("[data-thl-care-tabs]")).forEach(initCareTabs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllCareTabs);
  } else {
    initAllCareTabs();
  }
})();
